export default __webpack_public_path__ + "static/media/Excellence.7abd7b9f.svg";